import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const CatalogProductSettingsComponent = ({ selectCatalogSettings, handleInnerFormChange }: any) => {

    return (
        <>
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="UOM Enabled"
                    name="IsUOMEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ProductSettings.IsUOMEnabled',
                        selectCatalogSettings?.ProductSettings
                    )
                    }}
                    type="checkbox"
                    value={selectCatalogSettings?.ProductSettings?.IsUOMEnabled}
                />  
                <InputContainer
                    label="Stock Ledger Enabled"
                    name="IsStockLedgerEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ProductSettings.IsStockLedgerEnabled',
                        selectCatalogSettings?.ProductSettings
                    )
                    }}
                    type="checkbox"
                    value={selectCatalogSettings?.ProductSettings?.IsStockLedgerEnabled}
                /> 
            </div>
            }
        expandedPanel="Product Settings"
        headerTitle="Product Settings"
        />
        </>
  )
}
export default CatalogProductSettingsComponent;
